// @flow

import uniqWith from "lodash/uniqWith"
import isEqual from "lodash/isEqual"
import { AuthType } from "@cabonline/shared"
import type { ExternalAppType } from "shared/types/ExternalAppType"
import externalApps from "./external-apps"
import internalApps from "./internal-apps"
import { isProductionBuild } from "@cabonline/shared/utils/env"

class AppConfig {
  getExternalApps(): any {
    return externalApps
  }

  _sortByOrderPrio(a, b) {
    const aOrderPrio = a.orderPrio ? a.orderPrio : 0
    const bOrderPrio = b.orderPrio ? b.orderPrio : 0

    if (aOrderPrio < bOrderPrio) {
      return 1
    } else {
      return -1
    }
  }

  getInternalAppsForAuth(auth: typeof AuthType): any {
    const apps = []

    auth.permissions.map(permission => {
      const [app] = permission.split(":")

      const targetApp = internalApps[app]
      // If our app require one permission instead of a app permission
      if (
        targetApp &&
        targetApp.requirePermission &&
        targetApp.requirePermission === permission
      ) {
        apps.push(targetApp)
      } else if (targetApp && !targetApp.requirePermission) {
        apps.push(targetApp)
      }
      if (app === "settlement") apps.push(internalApps["backoffice"])
    })

    if (!isProductionBuild)
      Object.entries(internalApps).forEach(
        (app: any) => app[1].mocked === true && apps.push(app[1])
      )

    return uniqWith(apps, isEqual).sort(this._sortByOrderPrio)
  }

  getAppsForAuth(auth: typeof AuthType): Array<ExternalAppType> {
    const permissions = auth.permissions.slice()
    const authApps = this._mapPermissionsToExternalApps(permissions)
      .concat(this._mapPermissionsToStandaloneApps(permissions))
      .concat(this._addInternalDashboard(auth))
      .filter(val => val !== undefined)

    return uniqWith(authApps, isEqual)
  }

  _addInternalDashboard(auth: typeof AuthType) {
    const apps = this.getInternalAppsForAuth(auth)
    let hasAdmin = false

    apps.forEach(app => {
      if (
        typeof app["standalone"] === "undefined" ||
        app["standalone"] === false
      ) {
        hasAdmin = true
      }
    })

    if (hasAdmin) {
      return [externalApps["admin"]]
    } else {
      return []
    }
  }

  _mapPermissionsToStandaloneApps(permissions: Array<string>) {
    const apps = []

    permissions.map(permission => {
      const [app] = permission.split(":")

      if (internalApps[app] && internalApps[app].standalone) {
        apps.push(internalApps[app])
      }
    })

    return uniqWith(apps, isEqual)
  }

  _mapPermissionsToExternalApps(permissions: Array<string>) {
    const apps = []

    permissions.map(permission => {
      const [app] = permission.split(":")

      if (externalApps[app]) apps.push(externalApps[app])
    })

    return uniqWith(apps, isEqual)
  }
}

export default (new AppConfig(): AppConfig)
